export const menuList = [
    {
        name: 'HOME',
        path: '/',
    },
    {
        name: 'CROPPER',
        path: '/cropper',
    },
    {
        name: 'CONVERTER',
        path: '/converter',
    },
    // {
    //     name: 'RESIZER',
    //     path: '/resizer',
    // },
]
